var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.997,
    viewBox: "0 0 15 14.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_61",
    "data-name": "Layer 61",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21048",
    "data-name": "Path 21048",
    d: "M11.3,3.431H2.715A.715.715,0,1,1,2.715,2H11.3a.715.715,0,0,1,0,1.431Z",
    fill: "#58618d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21049",
    "data-name": "Path 21049",
    d: "M9.869,9.431H2.715A.715.715,0,1,1,2.715,8H9.869a.715.715,0,0,1,0,1.431Z",
    transform: "translate(0 -1.478)",
    fill: "#58618d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21050",
    "data-name": "Path 21050",
    d: "M8.438,15.431H2.715a.715.715,0,0,1,0-1.431H8.438a.715.715,0,0,1,0,1.431Z",
    transform: "translate(0 -2.956)",
    fill: "#58618d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    "data-name": "Path 21051",
    d: "M7.007,21.431H2.715a.715.715,0,1,1,0-1.431H7.007a.715.715,0,0,1,0,1.431Z",
    transform: "translate(0 -4.434)",
    fill: "#58618d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21052",
    "data-name": "Path 21052",
    d: "M17.715,15.566A.735.735,0,0,1,17,14.813V2.754a.716.716,0,1,1,1.431,0V14.813A.735.735,0,0,1,17.715,15.566Z",
    transform: "translate(-3.695)",
    fill: "#58618d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21053",
    "data-name": "Path 21053",
    d: "M16.86,20.576a.715.715,0,0,1-.508-.207l-2.146-2.146a.718.718,0,0,1,1.016-1.016l1.638,1.645L18.5,17.206a.718.718,0,0,1,1.016,1.016l-2.146,2.146A.715.715,0,0,1,16.86,20.576Z",
    transform: "translate(-2.724 -3.579)",
    fill: "#58618d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortby);
export default __webpack_public_path__ + "static/media/sortby.e6e4ff5e4f3fe714fdc998af0fe5a215.svg";
export { ForwardRef as ReactComponent };